import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle, Users, TrendingUp, Shield } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">About Profind.ca</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Profind.ca is Canada's premier platform for connecting homeowners with trusted local service professionals. We make it easy to find, compare, and hire qualified pros for any home project.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <CheckCircle className="h-10 w-10 text-orange-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Quality Professionals</h3>
              <p className="text-gray-600">We connect you with verified, top-rated service providers across Canada.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <Users className="h-10 w-10 text-orange-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Easy to Use</h3>
              <p className="text-gray-600">Request quotes, compare pros, and hire with confidence - all in one place.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <TrendingUp className="h-10 w-10 text-orange-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Grow Your Business</h3>
              <p className="text-gray-600">Professionals can expand their customer base and manage leads efficiently.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <Shield className="h-10 w-10 text-orange-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">Trust & Safety</h3>
              <p className="text-gray-600">We prioritize security and transparency in every interaction.</p>
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Our Mission</h2>
          <p className="text-gray-700 mb-6">
            Our mission is to simplify the process of finding and hiring home service professionals while helping businesses grow through quality lead generation.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Why Choose Profind.ca?</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>100% Free for homeowners</li>
            <li>Verified professional profiles</li>
            <li>Transparent pricing and reviews</li>
            <li>Quick and easy quote requests</li>
            <li>Secure payment processing</li>
            <li>Excellent customer support</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;